import { FileDownloadResponse } from '~types/downloads';

const ZIP_SIGNATURE = {
  FIRST_BYTE: 0x50,
  SECOND_BYTE: 0x4b,
};

export const getStreamableZipDownload = async ({
  blob,
  filename,
}: {
  blob: Blob;
  filename: string;
}): Promise<FileDownloadResponse | null> => {
  if (!(blob instanceof Blob)) {
    console.error('Download did not return a Blob. Type:', typeof blob);
    return null;
  }

  // Quick ZIP signature check (PK) – first two bytes should be 0x50 0x4B
  const sigBuf = await blob.slice(0, 4).arrayBuffer();
  const sig = new Uint8Array(sigBuf);
  const isZip = sig[0] === ZIP_SIGNATURE.FIRST_BYTE && sig[1] === ZIP_SIGNATURE.SECOND_BYTE;
  if (!isZip) {
    console.error('Invalid ZIP signature');
    return null;
  }

  return {
    data: blob,
    headers: {
      'content-disposition': `attachment; filename=${filename}`,
    },
  };
};
